module.exports = __webpack_public_path__ + "static/media/daihatsu-go-drive.cbf2d307.png";